export const INCREASE_CHAT_STEP  = (state, value) => {
  state.chatStep = value
}

export const TRIGGER_REPLY = (state) => {
  state.doReply = !state.doReply
}

export const TRIGGER_SCROLL_WINDOW = (state, value) => {
  state.scrollValue = window.scrollY + value
}

export const UPDATE_EARTH_POS = (state, value) => {
  state.positionTopEarth = value
}

export const UPDATE_AVATAR_POS = (state, value) => {
  state.positionTopAvatar = value
}

export const SET_SELECTED_ANSWER = (state, value) => {
  state.selectedAnswer = value
}

export const SET_RIGHT_REPLY = (state, value) => {
  state.isRightAnswer = value
}

export const SET_OVERLAY_TYPE = (state, value) => {
  state.openOverlayType = value
}

export const SET_MENU_CTA_VISIBILITY = (state, value) => {
  state.showMenuCta = value
}

export const IS_BROWSING_FROM_MENU = (state, value) =>  {
  state.chatNavigationMenu = value
}

export const CHANGE_BG_INDEX = (state, value) => {
  state.bgStep = value
}

export const CURRENT_BG_INDEX = (state, value) => {
  state.currentBgStepReload = value
}

export const SET_BADGE_TYPE = (state, value) => {
  state.openBadgeType = value
}

export const SELECT_BADGE = (state, value) => {
  state.badges[value] = true
}

export const END_CHAT = (state) => {
  state.finalStep = true
}